import React, { useEffect, useState } from 'react';
import CustomInput from '../../../components/customInput';
import DeleteCampaignModal from '../modal/deleteCampaignModal';
import API from '../../../services/api';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/dashboard/actions';
import utils from '../../../utils';
import CustomCalendar from '../../../components/customCalendar';
import CustomCheckBox from '../../../components/customCheckBox';

const CampaignInfo = ({ campaign, reloadCallback, onChange }) => {
  const [displayName, setDisplayName] = useState(campaign?.displayName || '');
  const [startTime, setStartTime] = useState(campaign?.startTime ? new Date(campaign.startTime) : null);
  const [endTime, setEndTime] = useState(campaign?.endTime ? new Date(campaign.endTime) : null);
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isOngoingCampaign, setIsOngoingCampaign] = useState(endTime ? endTime.getFullYear() === 9999 : false);

  const dispatch = useDispatch();

  useEffect(() => {
    setDisplayName(campaign?.displayName || '');
    setStartTime(campaign?.startTime ? new Date(campaign.startTime) : null);
    setEndTime(campaign?.endTime ? new Date(campaign.endTime) : null);
    setIsEditing(!campaign?.imported);
    setIsDeleteModalOpen(false);
    setIsDeleting(false);
  }, [campaign]);

  useEffect(() => {
    if (onChange) {
      onChange({
        ...campaign,
        displayName,
        startTime: startTime ? startTime.toISOString() : '',
        endTime: endTime ? (isOngoingCampaign ? new Date(9999, 11, 31).toISOString() : endTime.toISOString()) : '',
        isOngoingCampaign
      });
    }
  }, [displayName, startTime, endTime, isOngoingCampaign]);

  useEffect(() => {
    if (isEditing) {
      const endDateValue = endTime ? endTime.getFullYear() : null;
      if (endDateValue === 9999) {
        setEndTime(new Date());
      }
    } else {
      setEndTime(campaign?.endTime ? new Date(campaign.endTime) : null);
    }
  }, [isEditing]);

  const handleDeleteCampaign = () => {
    setIsDeleting(true);
    API.deleteCampaign(campaign.companyId, campaign.id)
      .then(() => {
        dispatch(setAlert(utils.generateAlert('Campaign deleted successfully!', 'success')));
      })
      .catch(error => {
        dispatch(setAlert(utils.generateAlert(`Error deleting campaign: ${error.message}`, 'danger')));
      })
      .finally(() => {
        setIsDeleting(false);
        setIsDeleteModalOpen(false);
        reloadCallback();
      });
  };

  const renderDate = dateString => {
    if (dateString) {
      const date = new Date(dateString);
      if (date.getFullYear() === 9999) {
        return 'Ongoing';
      }
      return date.toLocaleDateString('en-US');
    }
  };

  return (
    <div className="campaign-info-section">
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label>Campaign Name</label>
            <CustomInput
              label="Campaign Name"
              type="text"
              value={displayName}
              onChange={e => setDisplayName(e.target.value)}
              isEditable={isEditing}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Start Date</label>
            {isEditing ? (
              <CustomCalendar
                classes="simple-calendar"
                value={startTime}
                onChange={date => setStartTime(date)}
                showNeighboringMonth={false}
              />
            ) : (
              <CustomInput label="Start Date" type="date" value={renderDate(startTime)} />
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>End Date</label>
            {isEditing ? (
              <>
                <CustomCheckBox
                  selected={isOngoingCampaign ? 'all' : 'none'}
                  onClick={() => setIsOngoingCampaign(!isOngoingCampaign)}
                  label="Ongoing Campaign"
                />
                <CustomCalendar
                  classes="simple-calendar"
                  disabled={isOngoingCampaign}
                  value={endTime}
                  onChange={date => setEndTime(date)}
                  showNeighboringMonth={false}
                />
              </>
            ) : (
              <CustomInput label="End Date" type="date" value={renderDate(endTime)} />
            )}
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Created At</label>
            <CustomInput
              label="Created At"
              type="text"
              value={renderDate(campaign?.createTime) || ''}
              isEditable={false}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Last Updated</label>
            <CustomInput
              label="Last Updated"
              type="text"
              value={renderDate(campaign?.updateTime) || ''}
              isEditable={false}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Brand Portal</label>
            <CustomInput
              label="Brand Portal"
              type="text"
              value={campaign?.brandPortalDisplayName || '--'}
              isEditable={false}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Brand Portal ID</label>
            <CustomInput
              label="Brand Portal ID"
              type="text"
              value={campaign?.brandPortalId || '--'}
              isEditable={false}
            />
          </div>
        </div>
        {campaign?.imported && (
          <div className="col-12">
            <div className="form-group">
              <label>Imported</label>
              <CustomInput
                label="Imported"
                type="text"
                value={campaign.imported ? `Campaign from ${campaign.cms}` : 'No'}
                isEditable={false}
              />
            </div>
          </div>
        )}
        {/* {!campaign?.imported && (
          <div className="col-12">
            <div className="form-group d-flex justify-content-center align-items-center">
              <CustomButton
                title="Delete Campaign"
                classes="btn btn-danger"
                handleClick={() => setIsDeleteModalOpen(true)}
              />
            </div>
          </div>
        )} */}
      </div>
      <DeleteCampaignModal
        isOpen={isDeleteModalOpen}
        cancelCallback={() => setIsDeleteModalOpen(false)}
        confirmCallback={handleDeleteCampaign}
        isLoading={isDeleting}
      />
    </div>
  );
};

export default CampaignInfo;
